/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/file_rejected'
export default icon
